export const motionPresets = {
    fadeUp: {
        initial: { opacity: 0, y: 12 },
        animate: { opacity: 1, y: 0 },
        exit: { opacity: 0, y: 8 },
        transition: { type: 'spring', stiffness: 380, damping: 32 },
    },
    tabSwap: {
        initial: { opacity: 0, scale: 0.98 },
        animate: { opacity: 1, scale: 1 },
        exit: { opacity: 0, scale: 0.98 },
        transition: { duration: 0.18 },
    },
    longPressReveal: {
        initial: { height: 0, opacity: 0 },
        animate: { height: 'auto', opacity: 1 },
        exit: { height: 0, opacity: 0 },
        transition: { type: 'spring', stiffness: 420, damping: 36 },
    },
};
//# sourceMappingURL=motion.js.map